import { Component, Input } from '@angular/core';

@Component({
  selector: 'split-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
})
export class BadgeComponent {
  @Input() titles: Array<string> = [];
}
